<template>
  <!-- 蛋糕首页宫格：横向滚动，右侧渐变+箭头提示 -->
  <div class="page" v-if="category && category.length">
    <div class="scroll-outer" :class="{ 'scroll-outer--fade': showFade }">
      <div ref="scrollTrack" class="grid-scroll" :class="{ 'grid-scroll--static': !needScroll }" @scroll="onScroll">
        <div
          v-for="(item, index) in category"
          :key="index"
          class="grid-item"
          :style="{ width: itemWidth }"
          @click="onNavClick(item)"
        >
          <div class="icon-wrap">
            <img v-lazy="item.showImgId?.showImg" alt="" class="img" />
          </div>
          <div class="label">{{ item.name }}</div>
        </div>
      </div>
      <div v-if="showFade" class="scroll-hint" aria-hidden="true">
        <van-icon name="arrow" class="scroll-hint__icon" />
      </div>
    </div>
  </div>
</template>

<script>
import { queryAndNavigateHotShow } from '@/utils/categoryNav';
import { peekPageViewState } from '@/utils/pageScrollRestore';

const SCROLL_ITEM_WIDTH = 20; // >5 时每项 20%，一屏 5 个，第 6 个露出提示可滑

export default {
  name: 'CakeNavImage',
  props: {
    category: {
      type: Array,
      default: () => [],
    },
    pageKey: {
      type: String,
      default: '',
    },
    sectionKey: {
      type: String,
      default: '',
    },
    formContext: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showFade: false,
    };
  },
  computed: {
    needScroll() {
      return (this.category || []).length > 5;
    },
    itemWidth() {
      const n = this.category.length;
      // ≤5 按数量均分铺满；>5 固定宽度触发横滑
      if (n <= 5) {
        return `${100 / n}%`;
      }
      return `${SCROLL_ITEM_WIDTH}%`;
    },
  },
  watch: {
    category: {
      handler() {
        this.$nextTick(() => this.checkFade());
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkFade();
      this.tryRestoreScroll();
    });
  },
  activated() {
    this.tryRestoreScroll();
  },
  methods: {
    checkFade() {
      if (!this.needScroll) {
        this.showFade = false;
        return;
      }
      const el = this.$refs.scrollTrack;
      if (!el) {
        this.showFade = false;
        return;
      }
      this.showFade = el.scrollWidth > el.clientWidth + 2;
    },
    onScroll() {
      const el = this.$refs.scrollTrack;
      if (!el) return;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
      this.showFade = !atEnd && el.scrollWidth > el.clientWidth + 2;
    },
    getScrollLeft() {
      return this.$refs.scrollTrack ? this.$refs.scrollTrack.scrollLeft : 0;
    },
    setScrollLeft(scrollLeft) {
      if (this.$refs.scrollTrack && scrollLeft != null) {
        this.$refs.scrollTrack.scrollLeft = scrollLeft;
        this.onScroll();
      }
    },
    tryRestoreScroll() {
      if (!this.pageKey || !this.sectionKey) return;
      const state = peekPageViewState(this.pageKey);
      if (!state || !state.pending) return;
      const left = state.sections && state.sections[this.sectionKey];
      if (left == null) return;
      this.$nextTick(() => {
        this.setScrollLeft(left);
        this.checkFade();
      });
    },
    onNavClick(item) {
      queryAndNavigateHotShow(this, item, {
        hotType: 'D',
        listHotType: 'D',
        formOverrides: this.formContext,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/horizontalScrollHint.scss';

.page {
  background: #ffffff;
  border-radius: 0.4rem;
  padding: 0.75rem 0.25rem 0.65rem;
  margin-bottom: 0.4rem;
  box-sizing: border-box;
  width: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
}

.scroll-outer {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 4.85rem;

  @include horizontal-scroll-hint(#ffffff);
}

.grid-scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  width: 100%;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }

  &--static {
    overflow-x: hidden;
  }
}

.grid-item {
  flex-shrink: 0;
  text-align: center;
  box-sizing: border-box;
  scroll-snap-align: start;
  padding: 0.05rem 0;

  .icon-wrap {
    width: 3.35rem;
    height: 3.35rem;
    margin: 0 auto;
    border-radius: 0.5rem;
    overflow: hidden;
    background: #f7f7f7;
  }

  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .label {
    font-size: 0.75rem;
    line-height: 1.2;
    margin-top: 0.28rem;
    color: #333;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 0.15rem;
  }
}
</style>
